import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { AuthProvider } from "./store/AuthContext/AuthContext";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "./routes/NotFound/ErrorFallback";

import Landing from "./routes/Landing/Landing";
import Login from "./routes/Login/Login";
import Register from "./routes/Register/Register";
import RegisterForm from "./routes/RegisterForm/RegisterForm";
import LoginForm from "./routes/LoginForm/LoginForm";
import Verify from "./routes/Verify/Verify";
import Onboarding from "./routes/Onboarding/Onboarding";
import Privacy from "./routes/Privacy/Privacy";
import NotFound from "./routes/NotFound/NotFound";

import Library from "./routes/Library/Library";
import DocumentDetail from "./routes/DocumentDetail/DocumentDetail";
import Index from "./routes/Index/Index";
import Roadmap from "./routes/Roadmap/Roadmap";
import Settings from "./routes/Settings/Settings";
import Research from "./routes/Research/Research";
import ResearchChats from "./routes/Research/ResearchChats";


const router = createBrowserRouter([
  {
    path: "/",
    children: [
      { path: "", element: <Landing /> },
      { path: "login", element: <Login /> },
      { path: "register", element: <Register /> },
      { path: "register-form", element: <RegisterForm /> },
      { path: "login-form", element: <LoginForm /> },
      { path: "onboarding", element: <Onboarding /> },
      { path: "verify", element: <Verify /> },
      { path: "legal/privacy", element: <Privacy /> },
    ],
  },

  {
    path: "/client",
    children: [
      { path: "library", element: <Library /> },
      { path: "library/:id", element: <DocumentDetail /> },
      { path: "research", element: <Research /> },
      { path: "research/:query", element: <Research /> },
      { path: "research/chats", element: <ResearchChats /> },
      { path: "index", element: <Index /> },
      { path: "roadmap", element: <Roadmap /> },
      { path: "settings", element: <Settings /> },
    ],
    errorElement: <ErrorFallback />,
  },

  { path: "*", element: <NotFound /> },
]);


function App() {
  return (
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  );
}

export default App;
